import { useState,useEffect,useRef } from "react";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Dropdown,
  DropdownButton
  // InputGroup,
  // FormControl
} from "react-bootstrap";
import * as Const from "../common/const";


const SelectHelper = ({preventSubmitFunc,alwaysShowError,label,errorMessage,chooseText,validOptions,id,showDistrictFunc}) => {

  const [country, setCountry] = useState('');
const [error, setError] = useState('');
  const [touched, setTouched] = useState("0");

  const [showError, setShowError] = useState(alwaysShowError);

  var required;
  if(typeof errorMessage!=="undefined"){
    required=<span className="StarRed">*</span>
  }

  // Valid options for the country dropdown
  //const validOptions = ['Fritidsfartyg1', 'Fartyg i statlig tjänst', 'Handelsfartyg','Flodbåt','Militärfartyg','Sjöräddningsfartyg','Ospecifierad','Statsfartyg'];

  
  const handleOnChange = (e) => {
    setCountry(e.target.value) 
    setTouched("1");
    sessionStorage.setItem(id, e.target.value);
    if(e.target.value===Const.shipClassIdFishingShip)showDistrictFunc(true);
    else {
      showDistrictFunc(e.target.value);
    }
      

    //console.log('The button was touched!');
    
  };
  // Use useEffect to validate the selected value when it changes
 useEffect(() => {
    
  setCountry(sessionStorage.getItem(id));
  
  
  if (!validOptions.includes(country)) {

   
      if(alwaysShowError=='1'){
        setError(errorMessage); 
      }
      
      if(touched=="1"){
       setError(errorMessage);
       preventSubmitFunc('1')
    }
    } else {
      setError('');
      preventSubmitFunc('0')
    }



  }, [country, validOptions,touched,errorMessage,alwaysShowError,preventSubmitFunc,id]);

  /*useEffect(() => {
    
  }, [touched]);*/

  /*useEffect(() => {
    setShowError(alwaysShowError);
  }, [showError]);*/

  


  return (
<>
<Form.Group className="mb-3" controlId="formBasicEmail">
<Form.Label>{label} {required}</Form.Label>

<select className="form-select" value={country} onChange={handleOnChange} >
  <option value="" >{chooseText}</option>
  {validOptions.map((option) => (
    <option key={option} value={option}  >
      {option}
    </option>
  ))}
</select>

{error && <p className="text-danger form-text">{error}</p>}
</Form.Group>
</>
  )
}
  export default SelectHelper

  //(e) => (setCountry(e.target.value)  )